export default __webpack_public_path__ + "static/media/05_gsk.4d2a9468.png";